
import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import ResetUserPass from './resetUserPass';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class ViewResetPassword extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Reset Password',
                content: <ResetUserPass />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewResetPassword
